export const MAYOR = 1;
